import { render, staticRenderFns } from "./productupdate.vue?vue&type=template&id=973a97c8&scoped=true&"
import script from "./productupdate.vue?vue&type=script&lang=js&"
export * from "./productupdate.vue?vue&type=script&lang=js&"
import style0 from "./productupdate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./productupdate.vue?vue&type=style&index=1&id=973a97c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973a97c8",
  null
  
)

export default component.exports